// 自动扶梯检测项目数据
export const pageOneTreeData = [
  // A1.4 视频监控设施
  {
    id: 'A1.4',
    itemNumber: 'A1.4',
    description: '视频监控设施',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.4.1',
        itemNumber: 'A1.4.1',
        description: '视频监控要求',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A1.4.1-1',
            itemNumber: 'A1.4.1.1',
            description:
              '1.设置情况。现场检查公众聚集场所和住宅小区的电梯轿厢内、自动扶梯和自动人行道的出口或入口（需能监控到扶梯和人行道的运行全行程）是否设置视频监控设施，视频监控设施包含摄像头和监控终端。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.4.1-2',
            itemNumber: 'A1.4.1.2',
            description:
              '2.功能检查。摄像头拍摄的图像画面能清晰显示在监控终端的显示器或其它显示设备上，显示设备原则上要求安装在有人值守的场所；监控终端应当具有数据存储功能，数据的保存期不得少于 1 个月，所配置的存储设备容量应当满足要求。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  // A1.5 远程监测装置
  {
    id: 'A1.5',
    itemNumber: 'A1.5',
    description: '远程监测装置',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.5.1',
        itemNumber: 'A1.5.1',
        description: '远程监测要求',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A1.5.1-1',
            itemNumber: 'A1.5.1.1',
            description:
              '1.监测装置功能要求。远程监测装置应具有电梯运行实时数据信息采集和输出生成故障信息的功能，参照《电梯远程监测技术规范》（DB35/T2104-2022）规定。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.5.1-2',
            itemNumber: 'A1.5.1.2',
            description:
              '2.标准数据接口要求。通过标准数据接口应能直接无障碍读取电梯运行实时状态信息、故障信息和统计信息，标准数据接口应当满足《远程监测装置标准数据接口基本要求》。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.5.1-3',
            itemNumber: 'A1.5.1.3',
            description:
              '3.设置情况。现场检查乘客电梯是否配置远程监测装置，是否提供标准数据接口。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.5.1-4',
            itemNumber: 'A1.5.1.4',
            description:
              '4.功能检查。现场通过判断远程监测装置的采集方式和现场布置情况，查看标准数据接口是否符合要求，企业监测平台软件界面是否正确显示电梯运行实时数据，是否能够正确输出故障信息，并通过模拟故障随机抽查附件所列的部分信息进行验证。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A1.5.1-5',
            itemNumber: 'A1.5.1.5',
            description:
              '5.数据传输要求。检查电梯远程监测相关数据是否已根据要求，接入已具备条件的当地政府端电梯公共服务平台。检验人员通过当地市场监管部门授权的公共账户或所检电梯维保单位账户，登录当地政府端电梯公共服务平台，查看电梯远程监测的相关数据是否有效接入。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  // A1.6 机房通风降温措施
  {
    id: 'A1.6',
    itemNumber: 'A1.6',
    description: '机房通风降温措施',
    level: 1,
    result: '',
    children: [
      {
        id: 'A1.6.1',
        itemNumber: 'A1.6.1',
        description: '通风降温要求',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A1.6.1-1',
            itemNumber: 'A1.6.1.1',
            description:
              '检查电梯机房是否采取安装空调等通风降温措施。对通风降温措施不符合要求的，检验、检测机构（含自行检测单位）需提出整改意见，要求使用管理单位通过安装空调等措施，保证机房温度全年不超过 40℃。对不在夏季开展检验、检测的，应当要求使用管理单位提供书面承诺，对夏季机房温度进行监测，超过 40℃ 的，要采取安装空调等通风降温措施，确保机房温度不超过 40℃。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  // A2.1.1 使用资料
  {
    id: 'A2.1.1',
    itemNumber: 'A2.1.1',
    description: '使用资料',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.1.1.1',
        itemNumber: 'A2.1.1.1',
        description: '使用资料要求',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.1.1.1-1',
            itemNumber: 'A2.1.1.1.1',
            description:
              '(1)使用单位应提供以下适用于受检电梯的资料：电气原理图、安装使用维护保养说明书、检验和检测报告；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.1.1.1-2',
            itemNumber: 'A2.1.1.1.2',
            description:
              '(2)使用单位应提供以下适用于受检电梯的资料：日常使用状况记录、维护保养记录、运行故障和事故记录。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  // A2.2.1 机房、驱动站和转向站
  {
    id: 'A2.2.1',
    itemNumber: 'A2.2.1',
    description: '机房、驱动站和转向站',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.2.1.1',
        itemNumber: 'A2.2.1.1',
        description: '照明',
        level: 2,
        result: 'qualified',
        attachmentTable: '',
        children: [
          {
            id: 'A2.2.1.1-1',
            itemNumber: 'A2.2.1.1.1',
            description:
              '桁架内的驱动站、转向站以及机房中应设有电气照明；分离机房应设有永久性电气照明。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.1.2',
        itemNumber: 'A2.2.1.2',
        description: '接地保护措施',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.1.2-1',
            itemNumber: 'A2.2.1.2.1',
            description:
              '(1)电气设备及线管、线槽的外露可以导电部分与保护导体(PE，地线)可靠连接；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.1.2-2',
            itemNumber: 'A2.2.1.2.2',
            description:
              '(2)含有电气安全装置的电路发生接地故障时，驱动主机应立即停止运转。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.1.3',
        itemNumber: '*A2.2.1.3',
        description: '主开关',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.1.3-1',
            itemNumber: 'A2.2.1.3.1',
            description:
              '(1)主开关能够切断电动机、制动器和控制电路电源，但不能切断电源插座以及维护和检查所必需的照明电路的电源；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A2.2.1.3-2',
            itemNumber: 'A2.2.1.3.2',
            description:
              '(2)主开关在断开位置上能够被锁住或者使其处于"隔离"位置；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A2.2.1.3-3',
            itemNumber: 'A2.2.1.3.3',
            description:
              '(3)多台设备的主开关在同一个机器空间内时，各主开关的操作机构易于识别。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A2.2.1.4',
        itemNumber: '*A2.2.1.4',
        description: '停止开关',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.1.4-1',
            itemNumber: 'A2.2.1.4.1',
            description:
              '驱动站和转向站均应设有停止开关(已经设置了主开关的驱动站除外)。 驱动装置安装在梯级、踏板或者胶带的载客分支和返回分支之间或者设置在转向站外部的，在驱动装置附近应另设有停止开关。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.1.5',
        itemNumber: 'A2.2.1.5',
        description: '旋转部件防护措施',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.1.5-1',
            itemNumber: 'A2.2.1.5.1',
            description:
              '驱动主机的旋转部件、驱动站和转向站的梯级或者踏板转向部分应设有防护装置和警示标志，以防止人员受到伤害。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.1.6',
        itemNumber: 'A2.2.1.6',
        description: '工作制动器状态监测功能',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.1.6-1',
            itemNumber: 'A2.2.1.6.1',
            description:
              '受检设备启动后而工作制动器没有松开时，电气安全装置应能够使驱动主机立即停止运行；故障锁定功能应保持有效。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.1.7',
        itemNumber: 'A2.2.1.7',
        description: '手动盘车装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.1.7-1',
            itemNumber: 'A2.2.1.7.1',
            description:
              '(1)盘车手轮应是平滑和无辐条的，并且在其上或者附近清晰地标出操作说明和运行方向；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.1.7-2',
            itemNumber: 'A2.2.1.7.2',
            description:
              '(2)对于可拆卸式手动盘车装置，应设有最迟在该装置连接到驱动主机时起作用的电气安全装置。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.1.8',
        itemNumber: '*A2.2.1.8',
        description: '驱动链电气安全装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.1.8-1',
            itemNumber: 'A2.2.1.8.1',
            description:
              '当驱动主机驱动链过度松弛和断裂时，电气安全装置应能够使受检设备自动停止运行，并且能够触发附加制动器动作(设有附加制动器时)。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.1.9',
        itemNumber: '*A2.2.1.9',
        description: '检修控制装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.1.9-1',
            itemNumber: 'A2.2.1.9.1',
            description:
              '(1)在驱动站和转向站内至少提供一个用于便携式检修控制装置连接的检修插座，该插座的设置能够使检修控制装置到达受检设备的任何位置；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.1.9-2',
            itemNumber: 'A2.2.1.9.2',
            description: '(2)检修控制装置上的停止开关功能有效；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.1.9-3',
            itemNumber: 'A2.2.1.9.3',
            description: '(3)检修控制装置上的运行方向标识清晰、正确；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.1.9-4',
            itemNumber: 'A2.2.1.9.4',
            description:
              '(4)操作检修控制装置时，其他所有启动开关均不起作用，电气安全装置[本记录 A2.2.1.6 条、A2.2.2.6 条第(3)项、A2.2.2.7 条第(2)项、A2.2.3.2 条、A2.2.4.2 条、A2.2.4.3 条所述可以除外]有效；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.1.9-5',
            itemNumber: 'A2.2.1.9.5',
            description:
              '(5)当连接一个以上的检修控制装置时，所有检修控制装置均不起作用。',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.1.9-6',
            itemNumber: 'A2.2.1.9.6',
            description:
              '对于允许按照 GB16899—1997《自动扶梯与自动人行道的制造与安装安全规范》及更早期标准生产的受检设备，应符合本条 (1)~(3)项以及以下要求：①操作检修控制装置时，其他所有启动开关均不起作用，安全开关和安全电路仍起作用；② 当连接多个检修控制装置时，或者均不起作用，或者需要同时启动才能起作用。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      }
    ]
  },
  // A2.2.2 相邻区域
  {
    id: 'A2.2.2',
    itemNumber: 'A2.2.2',
    description: '相邻区域',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.2.2.1',
        itemNumber: 'A2.2.2.1',
        description: '梳齿与踏面相交线处的照度',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.1-1',
            itemNumber: 'A2.2.2.1.1',
            description:
              '在楼层板平面的梳齿与踏面相交线位置的照度应至少为 50lx。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.2.2',
        itemNumber: 'A2.2.2.2',
        description: '出入口区域',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.2-1',
            itemNumber: 'A2.2.2.2.1',
            description:
              '出入口区域应充分畅通，其宽度至少等于扶手带外缘距离加上每边各 80mm，纵深尺寸从扶手装置端部算起至少为 2.50m；该区域的宽度不小于扶手带外缘之间距离的 2 倍加上每边各 80mm 时，其纵深尺寸允许减少至 2.00m。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.2.3',
        itemNumber: '*A2.2.2.3',
        description: '出入口防护装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.3-1',
            itemNumber: 'A2.2.2.3.1',
            description:
              '对于人员在出入口可能接触到扶手带的外缘并且引起危险的区域，应设置能够防止乘客进入该区域的永久固定的防护装置，或者符合以下要求的永久固定的防护装置[对于未按照《电梯监督检验和定期检验规则》对出入口防护装置进行过监督检验的，允许只满足下列第①项要求]：①至少高出扶手带 100mm, 位于扶手带外缘 80mm~120mm 处；②从楼层板起高度不小于 1100mm。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.2.4',
        itemNumber: '*A2.2.2.4',
        description: '防护挡板',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.4-1',
            itemNumber: 'A2.2.2.4.1',
            description:
              '建筑障碍物会引起人员伤害的，应采取了预防措施。受检设备与楼板有交叉或者受检设备之间有交叉的，交叉处应设置垂直固定、无锐利边缘的封闭防护挡板，其位于扶手带上方的防护高度不小于 0.30m，并且延伸至扶手带外缘以下至少 25mm。扶手带外缘与任何障碍物之间的距离不小于 400mm 的，可以不设置防护挡板。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.2.5',
        itemNumber: 'A2.2.2.5',
        description: '扶手带距离',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.5-1',
            itemNumber: 'A2.2.2.5.1',
            description:
              '(1)墙壁或者障碍物与扶手带外缘之间的水平距离不小于 80mm，与扶手带下缘的垂直距离不小于 25mm；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.2.5-2',
            itemNumber: 'A2.2.2.5.2',
            description:
              '(2)对于邻近布置的受检设备，其扶手带外缘之间的距离不小于 160mm。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.2.6',
        itemNumber: '*A2.2.2.6',
        description: '连续输送保护',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.6-1',
            itemNumber: 'A2.2.2.6.1',
            description:
              '(1) 对于多台连续并且无中间出口的受检设备，应具有相同的运送能力并且同方向运行；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A2.2.2.6-2',
            itemNumber: 'A2.2.2.6.2',
            description:
              '(2) 对于多台连续并且无中间出口的受检设备，在梯级、踏板或者胶带到达梳齿与踏面相交线之前 2.00m~3.00m 处，应设有乘客易于触及的附加紧急停止开关；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A2.2.2.6-3',
            itemNumber: 'A2.2.2.6.3',
            description:
              '(3) 对于多台连续并且无中间出口的受检设备，当其中一台停止运行时，其他继续运行可能造成人流拥堵的设备也停止运行。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A2.2.2.7',
        itemNumber: '*A2.2.2.7',
        description: '检修盖板与楼层板',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.7-1',
            itemNumber: 'A2.2.2.7.1',
            description:
              '(1)检修盖板与楼层板的安装和固定应能够防止因人员踩踏或者自重作用而导致倾覆、翻转；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.2.7-2',
            itemNumber: 'A2.2.2.7.2',
            description:
              '(2)监测检修盖板和楼层板的电气安全装置能够在移除任何一块检修盖板或者楼层板时动作，机械结构能够保证只能先移除某块检修盖板或者楼层板的，至少在移除该块检修盖板或者楼层板时电气安全装置动作。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.2.8',
        itemNumber: '*A2.2.2.8',
        description: '梳齿与梳齿板',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.8-1',
            itemNumber: 'A2.2.2.8.1',
            description: '(1)梳齿板梳齿完好，无缺损；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.2.8-2',
            itemNumber: 'A2.2.2.8.2',
            description:
              '(2)梳齿板梳齿与踏板面齿槽的啮合深度至少为 4mm，梳齿槽根部与踏面的间隙不超过 4mm；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.2.8-3',
            itemNumber: 'A2.2.2.8.3',
            description:
              '(3)梯级或者踏板进入梳齿板处有异物卡入，并且梳齿与梯级或者踏板不能正常啮合而导致梳齿板与梯级或者踏板发生碰撞时，受检设备自动停止运行。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.2.9',
        itemNumber: '*A2.2.2.9',
        description: '紧急停止开关',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.9-1',
            itemNumber: 'A2.2.2.9.1',
            description:
              '(1)受检设备出入口附近设有紧急停止开关，必要时增设附加紧急停止开关，以使紧急停止开关之间的距离不超过 30m；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.2.9-2',
            itemNumber: 'A2.2.2.9.2',
            description:
              '(2)各紧急停止开关标识清晰，对于位于扶手装置高度 1/2 以下的紧急停止开关，在扶手装置高度 1/2 以上的醒目位置还应设有直径至少为 80mm 的红底白字"急停"指示标记，箭头指向该开关。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.2.10',
        itemNumber: 'A2.2.2.10',
        description: '铭牌与标志',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.2.10-1',
            itemNumber: 'A2.2.2.10.1',
            description:
              '(1)在受检设备出入口的明显位置应设有产品铭牌，至少标明产品名称、型号、编号、制造单位名称或者商标、制造日期(对于在本规则实施前已经投入使用的受检设备，可以在出入口的明显位置设置标有产品型号、编号、制造年份、制造单位名称或者商标的产品标识)；改造后的受检设备，加贴铭牌上应标明主要技术参数、改造单位名称或者商标、改造竣工日期；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.2.10-2',
            itemNumber: 'A2.2.2.10.2',
            description:
              '(2)在受检设备出入口附近应设有包括必须拉住小孩、必须抱着宠物、必须握住扶手带和禁止使用非专用手推车等内容的安全乘用图形标志。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  // A2.2.3 扶手装置和围裙板
  {
    id: 'A2.2.3',
    itemNumber: 'A2.2.3',
    description: '扶手装置和围裙板',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.2.3.1',
        itemNumber: '*A2.2.3.1',
        description: '扶手装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.1-1',
            itemNumber: 'A2.2.3.1.1',
            description:
              '(1)扶手带完好，表面应无龟裂、剥离、严重磨损，扶手带单一开裂处最大裂纹宽度不大于 3mm；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.3.1-2',
            itemNumber: 'A2.2.3.1.2',
            description:
              '(2)扶手转向端入口处的最低点与地板之间的垂直距离不小于 0.10m，并且不大于 0.25m；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.3.1-3',
            itemNumber: 'A2.2.3.1.3',
            description:
              '(3)朝向梯级、踏板或者胶带一侧的部分应光滑、平齐；装设方向与运行方向不一致的压条或者镶条凸出高度不大于 3mm，其边缘呈圆角或者倒角状；沿运行方向的盖板连接处结构能够防止勾绊；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.3.1-4',
            itemNumber: 'A2.2.3.1.4',
            description: '(4)扶手带入口保护装置功能有效。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.3.2',
        itemNumber: 'A2.2.3.2',
        description: '扶手带速度监测装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.2-1',
            itemNumber: 'A2.2.3.2.1',
            description:
              '当扶手带速度与梯级、踏板或者胶带实际速度偏差最大超过 15%，并且持续时间在 5s～15s 内时，扶手带速度监测装置应能够使受检设备自动停止运行。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.3.3',
        itemNumber: '*A2.2.3.3',
        description: '防爬装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.3-1',
            itemNumber: 'A2.2.3.3.1',
            description:
              '人员能够爬上外盖板并且存在跌落风险的，受检设备外盖板上应装设符合以下条件的防爬装置：①在位于地平面上方(1000±50)mm 处；②其高度至少与扶手带表面齐平，下部与外盖板相交，平行于外盖板方向上的延伸长度不小于 1000mm，并且在此长度范围内无踩脚处。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.3.4',
        itemNumber: '*A2.2.3.4',
        description: '阻挡装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.4-1',
            itemNumber: 'A2.2.3.4.1',
            description:
              '对于与墙相邻并且外盖板的宽度大于 125mm 的受检设备，或者相邻平行布置并且共用外盖板的宽度大于 125mm 的自动扶梯，在上、下端部装设的阻挡装置应能够防止人员进入外盖板区域，并且延伸到高度距离扶手带下缘 25mm～150mm 处。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.3.5',
        itemNumber: '*A2.2.3.5',
        description: '防滑行装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.5-1',
            itemNumber: 'A2.2.3.5.1',
            description:
              '自动扶梯和相邻的墙之间装有接近扶手带高度的扶手盖板，并且建筑物(墙)和扶手带中心线之间的距离大于 300mm 时，或者相邻自动扶梯的扶手带中心线之间的距离大于 400mm 时，在扶手盖板上装设的防滑行装置应无锐角或者锐边，与扶手带的距离不小于 100mm，并且防滑行装置之间的间隔距离不大于 1800mm，高度不小于 20mm。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.3.6',
        itemNumber: 'A2.2.3.6',
        description: '护壁板间隙',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.6-1',
            itemNumber: 'A2.2.3.6.1',
            description:
              '护壁板之间的间隙应不大于 4mm，其边缘应呈圆角或者倒角状。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.3.7',
        itemNumber: '*A2.2.3.7',
        description: '围裙板与梯级、踏板间隙',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.7-1',
            itemNumber: 'A2.2.3.7.1',
            description:
              '(1)任何一侧的水平间隙不大于 4mm，并且两侧对称位置处的间隙总和不大于 7mm；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.3.7-2',
            itemNumber: 'A2.2.3.7.2',
            description:
              '(2)围裙板设置在踏板之上时，踏板表面与围裙板下端的垂直间隙不大于 4mm，踏板侧边与围裙板垂直投影间不产生间隙。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      },
      {
        id: 'A2.2.3.8',
        itemNumber: 'A2.2.3.8',
        description: '围裙板防夹装置',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.8-1',
            itemNumber: 'A2.2.3.8.1',
            description: '(1)无松动、缺损等现象；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.3.8-2',
            itemNumber: 'A2.2.3.8.2',
            description:
              '(2)端点位于梳齿与踏面相交线前(梯级侧)不小于 50mm，但不大于 150mm 的位置。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.3.9',
        itemNumber: 'A2.2.3.9',
        description: '围裙板防夹开关',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.3.9-1',
            itemNumber: 'A2.2.3.9.1',
            description:
              '对于设有围裙板防夹开关的自动扶梯， 夹入梯级和围裙板之间的异物最迟到达围裙板防夹开关处时，该开关应能够有效动作，使自动扶梯在该梯级到达梳齿板前自动停止运行。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      }
    ]
  },
  // A2.2.4 梯级、踏板(胶带)及驱动元件
  {
    id: 'A2.2.4',
    itemNumber: 'A2.2.4',
    description: '梯级、踏板(胶带)及驱动元件',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.2.4.1',
        itemNumber: 'A2.2.4.1',
        description: '梯级、踏板(胶带)',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.4.1-1',
            itemNumber: 'A2.2.4.1.1',
            description: '(1)梯级、踏板或者胶带完好，无破损；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.2.4.1-2',
            itemNumber: 'A2.2.4.1.2',
            description:
              '(2)在工作区段内的任何位置，从踏面测得的两个相邻梯级或者踏板之间的间隙不大于 6mm。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.4.2',
        itemNumber: '*A2.2.4.2',
        description: '梯级、踏板下陷保护',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.4.2-1',
            itemNumber: 'A2.2.4.2.1',
            description:
              '梯级或者踏板下陷导致不再与梳齿啮合时，电气安全装置应能够使受检设备自动停止运行，并且下陷的梯级或者踏板不会到达梳齿与踏面相交线；故障锁定功能应保持有效。检测时，卸除 1～2 个梯级或者踏板，将缺口检修运行至电气安全装置处，检测人员检查电气安全装置至梳齿与踏面相交线的距离应大于工作制动器的最大制停距离；该装置动作后，应能够使使受检设备停止运行；故障锁定功能应保持有效。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.4.3',
        itemNumber: '*A2.2.4.3',
        description: '梯级、踏板缺失保护',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.4.3-1',
            itemNumber: 'A2.2.4.3.1',
            description:
              '由梯级或者踏板缺失而导致的缺口从梳齿板位置出现之前，电气安全装置应能够使受检设备自动停止运行；故障锁定功能应保持有效。检测时，卸除 1～2 个梯级或者踏板，将缺口运行至返回分支与回转段下部相接的直线段位置，正常启动受检设备上行和下行，检测人员分别确认缺口到达梳齿板位置之前，电气安全装置应能够使受检设备停止运行；故障锁定功能应保持有效。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.4.4',
        itemNumber: '*A2.2.4.4',
        description: '非操纵逆转保护',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.4.4-1',
            itemNumber: 'A2.2.4.4.1',
            description:
              '梯级、踏板或者胶带改变规定运行方向时，非操纵逆转保护装置应能够使自动扶梯自动停止运行；故障锁定功能应保持有效。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.4.5',
        itemNumber: '*A2.2.4.5',
        description: '驱动元件保护',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.4.5-1',
            itemNumber: 'A2.2.4.5.1',
            description:
              '直接驱动梯级、踏板或者胶带的元件断裂或者过分伸长时，受检设备应能够自动停止运行；故障锁定功能应保持有效。',
            level: 3,
            result: 'qualified'
          }
        ]
      },
      {
        id: 'A2.2.4.6',
        itemNumber: '*A2.2.4.6',
        description: '距离伸缩保护',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.2.4.6-1',
            itemNumber: 'A2.2.4.6.1',
            description:
              '驱动装置与转向装置之间的距离发生过分伸长或者缩短时，受检设备应能够自动停止运行。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  // *A2.3.1 运行试验
  {
    id: 'A2.3.1',
    itemNumber: '*A2.3.1',
    description: '运行试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.3.1.1',
        itemNumber: 'A2.3.1.1',
        description: '运行试验要求',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.3.1.1-1',
            itemNumber: 'A2.3.1.1.1',
            description:
              '(1)对于由使用者的进入而自动启动或者加速的受检设备，其在使用者到达梳齿与踏面相交线之前，受检设备应已经启动和加速，其运行方向标识应正确并且清晰可见；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.3.1.1-2',
            itemNumber: 'A2.3.1.1.2',
            description:
              '(2)对于由使用者的进入而自动启动的受检设备，当使用者从预定运行方向进入时，应经过足够的时间(至少为预期输送时间再加上 10s)才能自动停止运行；当使用者从预定运行方向相反的方向进入时，应仍按照预先确定的方向启动，运行时间不少于 10s；',
            level: 3,
            result: 'qualified'
          },
          {
            id: 'A2.3.1.1-3',
            itemNumber: 'A2.3.1.1.3',
            description:
              '(3)受检设备空载、以正常运行速度进行两个方向的连续运行，应运行平稳，无异常碰擦、干涉、松动、抖动和声响。',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  // *A2.3.2 扶手带运行速度偏差试验
  {
    id: 'A2.3.2',
    itemNumber: '*A2.3.2',
    description: '扶手带运行速度偏差试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.3.2.1',
        itemNumber: 'A2.3.2.1',
        description: '速度偏差要求',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.3.2.1-1',
            itemNumber: 'A2.3.2.1.1',
            description:
              '受检设备空载运行，分别测量、计算两个运行方向的扶手带运行速度相对于梯级、踏板或者胶带实际速度的偏差，其应在 0％～＋2%范围内。',
            level: 3,
            result: 'qualified',
            attachmentTable: 'table1'
          }
        ]
      }
    ]
  },
  // *A2.3.3 空载制停距离试验
  {
    id: 'A2.3.3',
    itemNumber: '*A2.3.3',
    description: '空载制停距离试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.3.3.1',
        itemNumber: 'A2.3.3.1',
        description: '制停距离要求',
        level: 2,
        result: 'qualified',
        children: [
          {
            id: 'A2.3.3.1-1',
            itemNumber: 'A2.3.3.1.1',
            description:
              '进行两个方向的空载制停距离试验，制停距离从用于制停的电气装置被触发时开始测量，测量自动扶梯的制停距离应当符合下表要求：',
            level: 3,
            result: 'qualified'
          }
        ]
      }
    ]
  },
  // *A2.3.4 附加制动器试验
  {
    id: 'A2.3.4',
    itemNumber: '*A2.3.4',
    description: '附加制动器试验',
    level: 1,
    result: '',
    children: [
      {
        id: 'A2.3.4.1',
        itemNumber: 'A2.3.4.1',
        description: '附加制动器要求',
        level: 2,
        result: 'notApplicable',
        children: [
          {
            id: 'A2.3.4.1-1',
            itemNumber: 'A2.3.4.1.1',
            description: '(1)在附加制动器动作开始时应能够强制切断控制电路；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A2.3.4.1-2',
            itemNumber: 'A2.3.4.1.2',
            description:
              '(2)受检设备空载，在工作制动器松开状态下，下行时触发附加制动器动作，附加制动器应能够使受检设备可靠制停；',
            level: 3,
            result: 'notApplicable'
          },
          {
            id: 'A2.3.4.1-3',
            itemNumber: 'A2.3.4.1.3',
            description:
              '(3)如果受检设备设有两个及以上驱动主机，并且采用工作制动器互为附加制动器时，每一制动器均应符合本条第(1)和第(2)项的要求。',
            level: 3,
            result: 'notApplicable'
          }
        ]
      }
    ]
  }
]

// 给每个最小项补充“是否打开过编辑弹窗”的默认状态
function initLeafDialogOpenFlag (nodes) {
  if (!Array.isArray(nodes)) return
  nodes.forEach(item => {
    if (!item || typeof item !== 'object') return
    const hasChildren = Array.isArray(item.children) && item.children.length > 0
    if (!hasChildren) {
      item.hasOpenedResultDialog = false
      return
    }
    initLeafDialogOpenFlag(item.children)
  })
}

initLeafDialogOpenFlag(pageOneTreeData)
